function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDigit9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "5.2314448mm",
    height: "7.7314448mm",
    viewBox: "0 0 5.2314448 7.7314448",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-73.035321,-58.180252)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m 77.108562,61.369705 q 0.0098,-0.06836 0.01465,-0.151367 0.0049,-0.08301 0.0049,-0.249023 0,-0.893555 -0.371094,-1.347657 -0.36621,-0.458984 -1.088867,-0.458984 -0.698242,0 -1.103515,0.419922 -0.400391,0.415039 -0.400391,1.137695 0,0.678711 0.356445,1.040039 0.356446,0.361328 1.025391,0.361328 0.439453,0 0.825195,-0.185547 0.385742,-0.185546 0.737305,-0.566406 z m -0.05371,0.78125 q -0.297852,0.336914 -0.751953,0.517578 -0.449219,0.180664 -0.986328,0.180664 -0.947266,0 -1.489258,-0.551757 -0.541992,-0.556641 -0.541992,-1.528321 0,-1.05957 0.664062,-1.699218 0.664063,-0.639649 1.777344,-0.639649 1.088867,0 1.689453,0.703125 0.600586,0.703125 0.600586,1.977539 0,1.254883 -0.483398,2.280274 -0.483399,1.02539 -1.367188,1.660156 -0.385742,0.27832 -0.839844,0.444336 -0.449218,0.166015 -0.791015,0.166015 -0.253906,0 -0.38086,-0.107421 -0.126953,-0.107422 -0.126953,-0.322266 0,-0.06348 0.05371,-0.283203 0.0098,-0.03906 0.01953,-0.05859 0.04883,0.0098 0.112305,0.01465 0.06348,0.0049 0.161133,0.0049 0.932617,0 1.674805,-0.756836 0.74707,-0.756836 1.005859,-2.001953 z",
    style: {
      fontSize: 10,
      fontFamily: "'Maiandra GD'",
      InkscapeFontSpecification: "'Maiandra GD, Normal'",
      stroke: "#000000",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigit9);
export default __webpack_public_path__ + "static/media/digit-9.d6aee0e0e7671c5ee87622159c286970.svg";
export { ForwardRef as ReactComponent };